import findKey from 'lodash/findKey';
export const getBlsKeyByReturnUrl = (blsList, blsReturnUrl)=>{
    const fullMatch = findKey(blsList, (url)=>url === blsReturnUrl);
    if (fullMatch) {
        return fullMatch;
    }
    const inputHost = new URL(blsReturnUrl).host;
    const matchingHostKey = findKey(blsList, (url)=>new URL(url).host === inputHost);
    return matchingHostKey || null;
};
